import React, { useState } from 'react';
import { FAQ_ITEMS } from '../../data/products';

const FaqAccordion = () => {
  return (
    <div
      style={{
        maxWidth: 780,
        margin: '0 auto',
        padding: '80px 24px',
      }}
    >
      <h2
        style={{
          fontFamily: 'Montserrat, sans-serif',
          fontWeight: 300,
          fontSize: 'clamp(20px, 3vw, 32px)',
          color: '#ffffff',
          letterSpacing: '0.15em',
          textTransform: 'uppercase',
          textAlign: 'center',
          marginBottom: 48,
        }}
      >
        FAQ
      </h2>
      <div>
        {FAQ_ITEMS.map((item, i) => (
          <FaqItem key={i} item={item} />
        ))}
      </div>
    </div>
  );
};

const FaqItem = ({ item }) => {
  const [open, setOpen] = useState(false);

  return (
    <div
      style={{
        borderBottom: '1px solid rgba(255,255,255,0.12)',
      }}
    >
      <button
        onClick={() => setOpen(!open)}
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '20px 0',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          textAlign: 'left',
        }}
      >
        <span
          style={{
            fontFamily: 'Montserrat, sans-serif',
            fontWeight: 500,
            fontSize: 'clamp(13px, 2vw, 16px)',
            color: '#ffffff',
            letterSpacing: '0.05em',
            paddingRight: 16,
          }}
        >
          {item.question}
        </span>
        <span
          style={{
            fontFamily: 'Montserrat, sans-serif',
            fontWeight: 300,
            fontSize: 22,
            color: 'rgba(255,255,255,0.5)',
            lineHeight: 1,
            flexShrink: 0,
            transition: 'transform 0.3s ease',
            transform: open ? 'rotate(45deg)' : 'rotate(0deg)',
          }}
        >
          +
        </span>
      </button>
      <div
        style={{
          maxHeight: open ? 300 : 0,
          overflow: 'hidden',
          transition: 'max-height 0.35s ease',
        }}
      >
        <p
          style={{
            fontFamily: 'Montserrat, sans-serif',
            fontWeight: 300,
            fontSize: 'clamp(12px, 1.8vw, 15px)',
            color: 'rgba(255,255,255,0.6)',
            lineHeight: 1.7,
            margin: 0,
            paddingBottom: 20,
          }}
        >
          {item.answer}
        </p>
      </div>
    </div>
  );
};

export default FaqAccordion;
